"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAccessCodeBody = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateAccessCodeBody = (0, validation_1.properties)({
    email: (0, validation_1.text)(),
});
//# sourceMappingURL=AccessCodeBody.js.map